import React from "react"
import ModuleCards from "./ModuleCards"
const PaymentCollectionSetup=()=>{
    return(
        <ModuleCards/>
    )
}

export default PaymentCollectionSetup